import { useOutletContext } from 'react-router';

import { ApplicationsTable } from '~domains/transactions/widgets/applications-table';

type TransactionsOutletContext = {
  headerSlot: HTMLElement | null;
};

export const LoansPage = () => {
  const { headerSlot } = useOutletContext<TransactionsOutletContext>();

  return <ApplicationsTable headerSlot={headerSlot} />;
};
